// extracted by mini-css-extract-plugin
export var leftArrow = "LeftArrowIcon-module__leftArrow___BeivZ";